import { MESApiService, type spParameter } from "@dexteel/mesf-core";

export const getAssetPath = async (AssetId: string | number | undefined) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "AssetId", value: Number.parseInt(AssetId as any) });

	const resp = await apiService.callV2("[MMS].[GetAssetPath]", parameters);
	return resp;
};

export const getAssetResources = async (
	AssetId: string | number | undefined,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({
		name: "AssetId",
		value: Number.parseInt(AssetId as string),
	});

	const resp = await apiService.callV2("[MMS].[GetAssetResources]", parameters);
	return resp;
};

export const getAssets = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetAssets]", []);
	return resp;
};
